import { CustomOffsetMessageType } from '@shared/core/custom-offsets'
import { useMutation, useQueryClient } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useAddCustomOffset() {
  const queryClient = useQueryClient()
  return useMutation(
    ({ offset, messageType }: { offset: number; messageType: CustomOffsetMessageType }) =>
      ApiService.CustomOffsets.addCustomOffset(offset, messageType),
    {
      onSuccess: (_, { messageType }) => {
        queryClient.invalidateQueries(['custom-offsets', messageType])
      },
    },
  )
}
